import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { AppConfig } from './app-config.interface';
import { appConfig } from './environment';

@Injectable({
  providedIn: 'root'
})
export class AppConfigService {

  private appConfig: AppConfig = appConfig;

  $appConfig: BehaviorSubject<AppConfig> = new BehaviorSubject(appConfig);

  constructor(private http: HttpClient) {}

  loadAppConfig() {
    return Promise.resolve().then(() => {
      this.appConfig = appConfig;
      this.$appConfig.next(appConfig);
    });
  }

  get config() {
    return this.appConfig;
  }
}

